export type BaseVxeTableSize = 'medium' | 'middle' | 'small' | 'mini'

/** vxe-table 原生 border 模式，显式传入时会覆盖 show* 组合 props */
export type BaseVxeTableBorder = boolean | 'default' | 'full' | 'outer' | 'inner' | 'none'

export const DEFAULT_NON_DRAGGABLE_VXE_COLUMN_KEYS = ['action', 'operate', 'operation']

export interface BaseVxeTableRowSelection {
  type?: 'checkbox' | 'radio'
  selectedRowKeys?: (string | number)[]
  onChange?: (
    selectedRowKeys: (string | number)[],
    selectedRows: Record<string, unknown>[]
  ) => void
  getCheckboxProps?: (record: Record<string, unknown>) => {
    disabled?: boolean
  }
}

export interface BaseVxeTableProps {
  columns: import('@/utils/vxeTableColumns').AntdLikeColumn[]
  dataSource?: Record<string, unknown>[]
  loading?: boolean
  /** 行主键，对齐 antd row-key（字符串字段名或函数） */
  rowKey?: import('@/utils/baseVxeTableRowKey').BaseVxeTableRowKey
  /** 行选择配置，对齐 antd row-selection */
  rowSelection?: BaseVxeTableRowSelection
  /** 持久化标识，配合 userId 写入 localStorage */
  persistKey?: string
  userId?: string | number
  /** 是否允许拖拽调整列顺序，默认 true */
  columnDraggable?: boolean
  /** 是否允许拖拽调整列宽，默认 true */
  columnResizable?: boolean
  /** 是否持久化列宽/列顺序，默认 true（需 persistKey） */
  persistColumns?: boolean
  /** 表格尺寸，默认 medium（对齐 antd middle） */
  size?: BaseVxeTableSize
  /** 是否显示表格外边框，默认 false */
  showOuterBorder?: boolean
  /** 是否显示横向分割线（行分隔），默认 true */
  showRowDivider?: boolean
  /** 是否显示纵向分割线（列分隔），默认 false */
  showColumnDivider?: boolean
  /** 高级：直接指定 vxe border 模式，会覆盖 showOuterBorder / showRowDivider / showColumnDivider */
  border?: BaseVxeTableBorder
  showOverflow?: boolean | string
  /** 禁止拖拽排序的列 key，默认 action / operate / operation */
  nonDraggableColumnKeys?: string[]
  /** 无数据或加载中时内容区最小高度（px） */
  emptyMinHeight?: number
  /** 加载动画距容器顶部的固定偏移（px），默认表头高度 + emptyMinHeight / 2 */
  loadingTopOffset?: number
  /** 树表配置，传入后按 children 展开 */
  treeConfig?: Record<string, unknown>
}
